module.exports = __webpack_public_path__ + "static/media/service_2.a1d7733c.jpg";